// extracted by mini-css-extract-plugin
module.exports = {"card":"ProductCard_card__H6hBn","img":"ProductCard_img__zke1u","content":"ProductCard_content__1CnH9","title":"ProductCard_title__AVa4m","text":"ProductCard_text__2aXZW"};